import React, { CSSProperties } from 'react';
import styles from './SpecialInstruction.module.scss';
import { OPTIONAL } from '../nestedmodifiers/components/common';

interface ISpecialInstructionProps {
	externalStyle: CSSProperties;
	label?: string;
	placeholder?: string;
	text?: string;
	handleChange: (value: string) => void;
}

const MAX_TEXT_ALLOWED = 33;

const SpecialInstruction: React.FC<ISpecialInstructionProps> = ({
	externalStyle,
	label,
	placeholder,
	text,
	handleChange,
	...props
}: ISpecialInstructionProps) => (
	<>
		<section className={styles.specialInstruction} {...props} style={externalStyle} id="specialInstruction">
			<div>
				<div className={styles.specialInstructionContainer}>
					<div className={styles.labelGroup}>
						<label className={styles.instructionLabel}>{label}</label>
						<label htmlFor="specialInstructions" className={styles.instructionLabel2}>
							Dressing on the side? No onions? Let us know here.
						</label>
					</div>
					<div className={styles.modifierOptional}>{OPTIONAL}</div>
				</div>
				<input
					className={styles.instructionTextarea}
					placeholder={placeholder}
					maxLength={MAX_TEXT_ALLOWED}
					onChange={(e) => handleChange(e.target.value)}
					value={text}
				/>
			</div>
		</section>
	</>
);

export default SpecialInstruction;
